import { useEffect,useState } from "react";
import arrowup from "../../assets/arrowup.png";

import Articles from "../../data/article.js";
import { useParams } from "react-router-dom";

const GuideFMS = ()=>{
    const [guidefmsarticle, setguidefmsarticle] = useState({});
    let { articleid } = useParams()
    useEffect(() => {
        const page = document.getElementById('guidefmstitle');
        page.scrollIntoView({behavior:'smooth',block:'start'});

        const backToTopButton = document.querySelector(".back-to-top");
        const scrollfunc = ()=>{
            if(backToTopButton)
                if(window.scrollY>100){
                    backToTopButton.style.display = "block";
                }else{  
                    backToTopButton.style.display = "none";
                }
        }
        window.addEventListener("scroll", scrollfunc);
        setguidefmsarticle(Articles[articleid]);
        return () => {
            setguidefmsarticle({});
        }
       
    },[]);

    return(
        <div id="guidefms" className="container " style={{paddingTop:"100px"}}>
            <h1 className="pb-5 text-uppercase buildingtech" id="guidefmstitle">
                {guidefmsarticle.title}
            </h1>

            <div className="text-center ">
                <img src={guidefmsarticle.image} className="fmspic w-75 mb-5"/>
                <p style={{textAlign:"justify", width:"75%", margin:"auto"}}>{guidefmsarticle.intro}</p>
            </div>

            <h3 className="text-center pb-5 pt-5">
                Table of Contents
            </h3>

            <div className="tableparent card mb-5">
                <div className="card-body toc">
                    {guidefmsarticle.sectionlink}
                </div>
            </div>
            <div className="articledetail">
              {guidefmsarticle.sections}
            </div>
             <div>
             <a className="back-to-top"  href="#guidefmstitle" 
                style={{position: "fixed",bottom:"4%", right:"44%"}}>
                    <img id="back-to-top" src={arrowup} style={{height:"40px", width:"50px"}} className="" alt="arrowup"/> 
                </a>
            </div>
        </div>
    )
}

export default GuideFMS;